module.exports = __webpack_public_path__ + "img/25-1.fa1f63eb.svg";